/**
 * sl-728o.7.3: Kanban View Tutorial Session
 *
 * 3 steps guiding the user through switching database views.
 */
import type { useI18n } from '@affine/i18n';

import type { TutorialSession } from '../../types';
import {
  ensureEdgelessMode,
  resolveDatabase,
  resolveDatabaseViewSwitcher,
} from './targets';

type I18n = ReturnType<typeof useI18n>;

export function createKanbanViewSession(t: I18n): TutorialSession {
  return {
    id: 'tutorial:kanban-view',
    context: {
      targetAudience: 'all',
      category: 'basics',
    },
    steps: [
      {
        targetResolver: resolveDatabase,
        title:
          t['com.streamlain.streamlain.tutorial.kanban-view.step1.title'](),
        content:
          t['com.streamlain.streamlain.tutorial.kanban-view.step1.content'](),
        animation: 'highlight',
        onEnter: ensureEdgelessMode,
        delay: 650,
        trigger: { type: 'manual' },
        position: 'top',
      },
      {
        targetResolver: resolveDatabaseViewSwitcher,
        title:
          t['com.streamlain.streamlain.tutorial.kanban-view.step2.title'](),
        content:
          t['com.streamlain.streamlain.tutorial.kanban-view.step2.content'](),
        animation: 'pulse',
        trigger: { type: 'manual' },
        position: 'bottom',
      },
      {
        targetResolver: resolveDatabase,
        title:
          t['com.streamlain.streamlain.tutorial.kanban-view.step3.title'](),
        content:
          t['com.streamlain.streamlain.tutorial.kanban-view.step3.content'](),
        animation: 'highlight',
        trigger: { type: 'manual' },
        position: 'top',
      },
    ],
  };
}
